/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import { graphql, useStaticQuery } from "gatsby";
import PropTypes from "prop-types";
import React from "react";

import OG_IMAGE from "../../../assets/images/desk.jpg";
import TWITTER_IMAGE from "../../../assets/images/desk.jpg";

interface Params {
  lang?: string;
  meta?: [];
  title?: string;
  subtitle?: string;
  author?: string;
  socialImage?: string;
  description?: string;
  isArticle?: boolean;
  slug?: string;
}

function SEO({
  description = "",
  lang = "en",
  meta = [],
  title,
  subtitle,
  author,
  socialImage,
  slug,
  isArticle = false,
}: Params) {
  const { site }: Queries.SeoComponentQuery = useStaticQuery(graphql`
    query SeoComponent {
      site {
        siteMetadata {
          title
          description
          author
          siteUrl
          twitterUsername
          threadsUsername
          githubUsername
        }
      }
    }
  `);

  description = description?.length
    ? description
    : (site?.siteMetadata?.description as string);

  const siteTitle = site?.siteMetadata?.title as string;

  const twitterUsername =
    site?.siteMetadata?.twitterUsername ??
    (site?.siteMetadata?.author as string);

  const siteUrl = site?.siteMetadata?.siteUrl as string;
  let pageUrl = siteUrl;
  if (!pageUrl.endsWith("/")) {
    pageUrl += "/";
  }

  if (slug) {
    if (slug.startsWith("/")) {
      slug = slug.substring(1);
    }

    pageUrl += slug;
  }

  author = (author ?? site?.siteMetadata?.author) as string;

  title = title && subtitle ? `${title} | ${subtitle}` : title;

  const _meta = [
    {
      name: `image`,
      content: socialImage ? siteUrl + socialImage : siteUrl + OG_IMAGE,
    },
    {
      name: `description`,
      content: description,
    },
    {
      name: `author`,
      content: author,
    },
    {
      property: `og:image`,
      content: socialImage ? siteUrl + socialImage : siteUrl + OG_IMAGE,
    },
    {
      property: `og:url`,
      content: pageUrl,
    },
    {
      property: `og:title`,
      content: title ?? siteTitle,
    },
    {
      property: `og:description`,
      content: description,
    },
    {
      property: `og:type`,
      content: isArticle ? `article` : `website`,
    },
    {
      name: `twitter:image:src`,
      content: socialImage ? siteUrl + socialImage : siteUrl + TWITTER_IMAGE,
    },
    {
      name: `twitter:domain`,
      content: siteUrl,
    },
    {
      name: `twitter:card`,
      content: `summary_large_image`,
    },
    {
      name: `twitter:creator`,
      content: `@${twitterUsername}`,
    },
    {
      property: `twitter:title`, // NOTE: property
      content: title ?? siteTitle,
    },
    {
      property: `twitter:description`, // NOTE: property
      content: description,
    },
  ].concat(meta ?? []);

  return (
    <>
      <title>{title ?? siteTitle}</title>

      <meta httpEquiv="content-language" content={lang}></meta>

      {_meta
        .filter((item) => !!item.name)
        .map((item) => (
          <meta key={item.name} name={item.name} content={item.content}></meta>
        ))}
      {_meta
        .filter((item) => !!item.property)
        .map((item) => (
          <meta
            key={item.property}
            property={item.property}
            content={item.content}
          ></meta>
        ))}
    </>
  );
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
};

export default SEO;
